// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"172":"b3857b15","568":"888870ab","592":"d81bc9a0"}[chunkId] + ".chunk.js";
};